var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoLanguageSetting24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_LanguageSetting24x24",
    transform: "translate(-2.155 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "language",
    transform: "translate(2.155 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24188",
    transform: "translate(2.448 2.788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43651",
    d: "M.4,0H.239L0,1.2H.638Z",
    fill: "#999"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24190",
    transform: "translate(7.761 5.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43652",
    d: "M0,0A3.1,3.1,0,0,0,.479.878,3.3,3.3,0,0,0,1.037,0Z",
    fill: "#999"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24192",
    transform: "translate(4.938 1.852)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43653",
    d: "M4.548,0H.8l.8,6.3a1.287,1.287,0,0,1-.239.718L0,8.538H4.548a.886.886,0,0,0,.878-.878V.958A.822.822,0,0,0,4.548,0Zm0,3.351h-.08A4.436,4.436,0,0,1,3.75,4.708a4.385,4.385,0,0,0,.718.559c.08.08.16.319,0,.4-.08.16-.239.16-.4.08-.239-.16-.479-.4-.718-.559-.239.16-.479.4-.718.559a.376.376,0,0,1-.479-.08.278.278,0,0,1,.08-.4,4.385,4.385,0,0,0,.718-.559,3.39,3.39,0,0,1-.8-1.356h-.08a.343.343,0,0,1-.319-.319.343.343,0,0,1,.319-.319h.878V2.474a.343.343,0,0,1,.319-.319.343.343,0,0,1,.319.319v.319h.958a.343.343,0,0,1,.319.319c0,.16-.08.239-.319.239Z",
    fill: "#999"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43654",
    d: "M4.947.8A.82.82,0,0,0,4.069,0H.878A.886.886,0,0,0,0,.878V7.66a.886.886,0,0,0,.878.878H5.665a.415.415,0,0,0,.16-.319C5.9,8.219,4.947.8,4.947.8ZM3.75,5.825c-.16.08-.319-.08-.4-.239h0l-.16-.958H2.314l-.16.958a.439.439,0,0,1-.4.239c-.16-.08-.239-.16-.239-.319l.638-3.112c0-.16.16-.239.319-.239h.638a.36.36,0,0,1,.239.239L3.99,5.506C3.99,5.665,3.91,5.825,3.75,5.825Z",
    fill: "#999"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24196",
    transform: "translate(3.567 9.198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43655",
    d: "M0,0,.08.4a1.015,1.015,0,0,0,.559.718L1.6,0Z",
    fill: "#999"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_46760",
    d: "M19.927,15.291v.958a.343.343,0,0,1-.319.319l-.958.16a5.541,5.541,0,0,1-.4,1.037l.559.8a.509.509,0,0,1,0,.479l-.319.319-.319.319a.4.4,0,0,1-.479,0l-.8-.559a4.008,4.008,0,0,1-1.037.4l-.16.958a.343.343,0,0,1-.319.319h-.958a.343.343,0,0,1-.319-.319l-.16-.958a4.881,4.881,0,0,1-.958-.4l-.8.559a.293.293,0,0,1-.239.08c-.08,0-.16-.08-.239-.08l-.319-.319-.319-.319a.3.3,0,0,1,0-.479l.559-.718a4.881,4.881,0,0,1-.4-.958,7.471,7.471,0,0,0,1.277-.319,2.542,2.542,0,0,0,2.474,1.755,1.358,1.358,0,0,0,.559-.08,2.588,2.588,0,0,0,1.915-3.112,2.627,2.627,0,0,0-1.835-1.915,3.345,3.345,0,0,0,.319-1.277,4.881,4.881,0,0,1,.958.4l.8-.559a.293.293,0,0,1,.239-.08c.08,0,.16.08.239.08l.319.319.319.319a.3.3,0,0,1,0,.479l-.559.8a4.008,4.008,0,0,1,.4,1.037l.958.16C19.767,15.051,19.927,15.131,19.927,15.291Z",
    transform: "translate(-1.772 -1.796)",
    fill: "#999"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoLanguageSetting24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_LanguageSetting24x24.d3551a2ee6090746586bb471d9a17fc2.svg";